export interface Serviser {
  id: string
  region: string
  regionEn?: string
  regionRu?: string
  name: string
  nameRu?: string
  email: string
  phone?: string
}

export const servisers: Serviser[] = [
  {
    id: 'pancevo',
    region: 'Pančevo, Južnobanatski okrug',
    regionEn: 'Pančevo, South Banat District',
    regionRu: 'Панчево, Южно-Банатский округ',
    name: 'Ivan Martinović',
    nameRu: 'Иван Мартинович',
    email: 'servis@dtech.rs',
  },
  {
    id: 'bg-sever',
    region: 'Beograd (Surčin)',
    regionEn: 'Belgrade (Surčin)',
    regionRu: 'Белград (Сурчин)',
    name: 'Zlatan Zeljić',
    nameRu: 'Златан Зельич',
    email: 'servis@dtech.rs',
  },
  {
    id: 'bg-lestane',
    region: 'Beograd (Leštane)',
    regionEn: 'Belgrade (Leštane)',
    regionRu: 'Белград (Лештане)',
    name: 'Ivan Pešić',
    nameRu: 'Иван Пешич',
    email: 'servis@dtech.rs',
  },
]
